import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialYouTubeSvg } from "./IconSocialYouTubeSvg.mjs";
const IconSocialYouTube = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialYouTubeSvg, ...svgProps }) });
export {
  IconSocialYouTube
};
